import { apiUrl } from "@/services/apiBase.ts";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useAppInfoStore = defineStore("appInfo", () => {
  const apiVersion = ref<string | null>(null);

  /** Version string trimmed to everything before the first '+' (e.g. "1.0.0"). */
  const apiVersionDisplay = computed<string | null>(() => {
    if (!apiVersion.value) return null;
    const plusIdx = apiVersion.value.indexOf("+");
    return plusIdx === -1
      ? apiVersion.value
      : apiVersion.value.slice(0, plusIdx);
  });

  async function fetchApiVersion(): Promise<void> {
    try {
      const response = await fetch(apiUrl("/api/Version"));
      if (!response.ok) return;
      const data = (await response.json()) as { version: string };
      apiVersion.value = data.version;
      console.log("[AppInfo] App version:", __APP_VERSION__);
      console.log("[AppInfo] API version:", data.version);
    } catch {
      // Non-fatal — UI falls back to "Unavailable"
    }
  }

  return { apiVersion, apiVersionDisplay, fetchApiVersion };
});
